import { render } from "./usuarios.vue?vue&type=template&id=4568cc42&scoped=true"
import script from "./usuarios.vue?vue&type=script&lang=js"
export * from "./usuarios.vue?vue&type=script&lang=js"

import "./usuarios.vue?vue&type=style&index=0&id=4568cc42&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\easyturno\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4568cc42"]])

export default __exports__